"use client";

import { useTheme, type Theme } from "@/lib/theme";

const options: { id: Theme; label: string }[] = [
  { id: "light", label: "Claro" },
  { id: "dark", label: "Escuro" },
  { id: "system", label: "Sistema" },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div
      role="group"
      aria-label="Tema"
      className="inline-flex gap-0.5 rounded-lg border p-0.5"
      style={{ borderColor: "var(--line)", background: "var(--surface)" }}
    >
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={theme === option.id}
          onClick={() => setTheme(option.id)}
          className="rounded-md px-2.5 py-1 text-sm font-semibold transition-colors"
          style={{
            background: theme === option.id ? "var(--accent)" : "transparent",
            color: theme === option.id ? "var(--accent-fg)" : "var(--fg)",
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
